import { createIntegrationSettingsRoute } from '../integrationSettingsRoute';

const Index = () => import('./Index.vue');

export default createIntegrationSettingsRoute({
  path: 'accounts/:accountId/settings/tms-integration',
  headerTitle: 'TMS_INTEGRATION_SETTINGS.HEADER',
  routeName: 'settings_tms_integration',
  component: Index,
  roles: ['administrator', 'master'],
});
